import React from 'react'
import Link from 'gatsby-link'
import scrollTo from 'gatsby-plugin-smoothscroll'

import cx from '../../utils/cx'

export default function HeaderLink({
  text,
  id,
  isActive,
  setIsOpen,
  isContact,
  linkClassNames,
}) {
  // TODO: Should refactor this
  const linkClasses = cx(
    'transition-colors ease-out',
    setIsOpen && 'hover:text-blue',
    isActive && 'text-blue',
    isContact &&
      'group-hover:text-white group-hover:bg-gray-400 bg-blue-high text-white px-3 py-2 rounded',
    isActive && isContact && '!bg-blue',
    linkClassNames
  )

  const isHome =
    typeof window !== `undefined` && window.location.pathname === '/'

  if (!isHome) {
    return (
      <Link className={linkClasses} to={`/#${id}`}>
        {text}
      </Link>
    )
  }

  return (
    <a
      className={cx(linkClasses)}
      href={`#${id}`}
      onClick={(e) => {
        e.preventDefault()
        scrollTo(`#${id}`)
        if (setIsOpen) {
          setIsOpen(false)
        }
      }}
    >
      {text}
    </a>
  )
}
